// extracted by mini-css-extract-plugin
export default {"menu":"logs_menu__U8q5+","filterRow":"logs_filterRow__74ej0","filterWrap":"logs_filterWrap__xGfmb"};